// extracted by mini-css-extract-plugin
export default {"Page":"ForgotPasswordPage_Page__+mzon","ForgotPasswordBlock":"ForgotPasswordPage_ForgotPasswordBlock__J2Brb","ForgotPasswordTitle":"ForgotPasswordPage_ForgotPasswordTitle__4FXAo"};